export const ROLES = {
    SuperUser: 'SuperUser',
    CompanyAdmin: 'CompanyAdmin',
    CompanySupervisor: 'CompanySupervisor',
    TradesPerson: 'TradesPerson',
    Unregistered: 'Unregistered',
}
